import React, { useEffect } from 'react';
// // import Globe from 'react-globe.gl';

// // import Globe from "https://unpkg.com/react-globe.gl@2.24.1/dist/react-globe.gl.min.js"

function VulnerabilityGlobe({ data }) {
  return <></>

//   return (
//     <Globe
//       globeImageUrl="//unpkg.com/three-globe/example/img/earth-night.jpg"
//       pointsData={data}
//       pointAltitude="size"
//       pointColor="color"
//     />
//   )
}

export default VulnerabilityGlobe
